import Party from './Party'
import Riding from './Riding'

export default class Candidate {
  public name: string
  public party: Party
  public riding: Riding

  public constructor(name: string, party: Party, riding: Riding) {
    this.name = name
    this.party = party
    this.riding = riding
  }

  public get partyKey(): string {
    return this.party.key
  }

  public get key(): string {
    return `${this.riding.key}-${this.party.key}`
  }
}
